/* eslint-disable import/no-cycle */
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-explicit-any */
import BaseService, { CATEGORY_PORTAL } from "./core/BaseService";
import { TrainingTypes } from "../../Constants";
import valueOf from "../valueOf";

const CategoryTreeItemCategoryTypes = {
    CATEGORY: 0,
    OTHERS: 1,
};

/** 種別({@link CategoryTreeItem.type})の型定義. */
type CategoryTreeItemCategoryType = valueOf<typeof CategoryTreeItemCategoryTypes>;

/** 研修種別({@link CategoryTreeItem.careerType})の型定義. */
type CategoryTreeItemCareerType = keyof typeof TrainingTypes;

/** ペイロード. */
export interface CategoryTreePayload {
    isMobile?: boolean;
}

/** カテゴリ情報. */
export interface CategoryTreeItem {
    id: string;
    text: string;
    type: CategoryTreeItemCategoryType;
    careerType: CategoryTreeItemCareerType;
    level?: string;
    parentId?: string;
    count: number;
    allCount: number;
    children?: CategoryTreeItem[];
}

/** レスポンス. */
export interface CategoryTreeResponse {
    treeList: CategoryTreeItem[];
}

/** 分類データ取得API[POST /categoryTree]の呼び出しクラス. */
class CategoryTreeService extends BaseService {
    constructor() {
        super(CATEGORY_PORTAL, "categoryTree");
    }

    /**
     * Fetchを実行する.
     *
     * @param payload ペイロード({@link CategoryTreePayload})
     * @returns
     */
    public async fetch(payload: CategoryTreePayload): Promise<CategoryTreeResponse> {
        return super.postWithPromise(payload).then((json: any) => json as CategoryTreeResponse);
    }
}

export default CategoryTreeService;
